import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const lexicalsManifest: FeatureManifest = {
  id: 'lessons-lexicals',
  path: 'lessons/knowledge/lexicals/*',
  navPath: '/lessons/knowledge/lexicals',
  label: 'Từ vựng',
  description: 'Kho từ vựng dùng chung cho bài học',
  navigationGroup: { id: 'lessons', label: 'Bài học' },
  load: () => import('./entry'),
}
